'use strict'

var regexCheck = require('../util/regex-check.js')

var asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/)

module.exports = asciiAtext
